"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutsetaClient = exports.OutsetaAccountStage = exports.OutsetaSubscriptionId = void 0;
const axios_1 = __importDefault(require("axios"));
const outseta_api_client_1 = __importDefault(require("outseta-api-client"));
const account_stage_1 = require("outseta-api-client/dist/models/crm/account-stage");
Object.defineProperty(exports, "OutsetaAccountStage", { enumerable: true, get: function () { return account_stage_1.AccountStage; } });
require("./fetch-polyfill");
var OutsetaSubscriptionId;
(function (OutsetaSubscriptionId) {
    OutsetaSubscriptionId["Free"] = "RyW1VgmB";
    OutsetaSubscriptionId["LegacyProfi"] = "VdQGkpQ4";
    OutsetaSubscriptionId["LegacyPrivate"] = "aOW4E3mg";
    OutsetaSubscriptionId["Vacation"] = "rQVPELW6";
    OutsetaSubscriptionId["Collector"] = "NmdeZOQ0";
    OutsetaSubscriptionId["Starter"] = "E9LdG59w";
    OutsetaSubscriptionId["Trader"] = "rmkAZk9g";
    OutsetaSubscriptionId["Professional"] = "vWyXrM9b";
    OutsetaSubscriptionId["Shop"] = "MQvkZb9Y";
    OutsetaSubscriptionId["Powerseller"] = "yWor4N9D";
    OutsetaSubscriptionId["CusNeoxuan"] = "y9qo7qmA";
    OutsetaSubscriptionId["CusRoca"] = "dQGnlom4";
})(OutsetaSubscriptionId = exports.OutsetaSubscriptionId || (exports.OutsetaSubscriptionId = {}));
const OUTSETA_EMAIL_INCREASE_ID = '2amRadWJ';
const OUTSETA_EMAIL_DECREASE_ID = 'O79OAomE';
class OutsetaClient {
    constructor({ key, secret, subdomain, } = {}) {
        const apiKey = key || process.env.OUTSETA_API_KEY;
        const secretKey = secret || process.env.OUTSETA_API_SECRET;
        if ((!apiKey || !secretKey) && process.env.NODE_ENV === 'production')
            throw new Error('Outseta client initialized without key and secret');
        this.tauthToken = `Outseta ${apiKey}:${secretKey}`;
        this.api = new outseta_api_client_1.default({
            subdomain: subdomain || 'mtg-powertools',
            apiKey,
            secretKey,
        });
    }
    request(method, route, data) {
        return axios_1.default.request({
            method,
            baseURL: 'https://mtg-powertools.outseta.com/api/v1/',
            url: route,
            data,
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.tauthToken,
            },
        });
    }
    changeSubscription({ newTierId, currentSubId, outsetaAccountId, discountId, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const outsetaDiscount = !discountId
                ? undefined
                : yield this.request('GET', `public/billing/discountcoupons/${discountId}?planUid=${newTierId}`);
            if (discountId && !outsetaDiscount)
                throw new Error('discountError');
            const payload = {
                Account: { Uid: outsetaAccountId },
                BillingRenewalTerm: 1,
                SubscriptionAddOns: [],
                Plan: {
                    Uid: newTierId,
                },
                DiscountCouponSubscriptions: outsetaDiscount
                    ? [{ DiscountCoupon: outsetaDiscount.data, RedeemedDate: new Date() }]
                    : undefined,
            };
            if (currentSubId) {
                yield this.api.billing.subscriptions.update(Object.assign(Object.assign({}, payload), { Uid: currentSubId }));
            }
            else {
                yield this.api.billing.subscriptions.add(payload);
            }
        });
    }
    cancelSubscription(accountId, unsubComment, unsubReasons) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.api.crm.accounts.cancel({
                Account: { Uid: accountId },
                CancelationReason: unsubReasons,
                Comment: unsubComment,
            });
        });
    }
    removeCancelSubscription(accountId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.api.crm.accounts.removeCancellation(accountId);
        });
    }
    getReferredAccounts() {
        return __awaiter(this, void 0, void 0, function* () {
            //outsetaapiclient does not have sorting
            const accounts = yield this.api.crm.accounts.getAll({
                fields: 'Uid,Name,ReferralCode,Created,Updated',
                limit: 100,
                orderBy: 'Created DESC',
            });
            return accounts.items.filter((a) => a.ReferralCode);
        });
    }
    changeAccountStage({ newStage, id, }) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.api.crm.accounts.update({ Uid: id, AccountStage: newStage });
        });
    }
    getAccountsByStage({ stage }) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api.crm.accounts.getAll({ accountStage: stage });
        });
    }
    updateSubCostAndNotify({ personId, email, newCost, isIncrease, }) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.updatePersonData({ Uid: personId, AnnouncedSubscriptionCost: newCost });
            // sleep for 2 seconds, to give Outseta the time to update
            yield new Promise((resolve) => setTimeout(resolve, 2000));
            const LIST_ID = isIncrease ? OUTSETA_EMAIL_INCREASE_ID : OUTSETA_EMAIL_DECREASE_ID;
            yield this.api.marketing.emailListSubscriptions.add({
                EmailList: { Uid: LIST_ID },
                Person: { Email: email, Uid: personId },
                SendWelcomeEmail: true,
            });
            const subResponse = yield this.api.marketing.emailListSubscriptions.getAll(LIST_ID);
            const deletePayload = {
                EmailList: { Uid: LIST_ID },
                //the id of the subscription goes here, not the person id
                Person: { Uid: subResponse.items[0].Uid },
            };
            yield this.api.marketing.emailListSubscriptions.delete(deletePayload);
        });
    }
    updateAccountData(account) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.api.crm.accounts.update(account);
        });
    }
    updatePersonData(person) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.api.crm.people.update(person);
        });
    }
    getAccessToken(username) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.request('POST', 'tokens', {
                username: username,
                password: '',
                grant_type: 'password',
                client_id: 'outseta_auth_widget',
            });
            return response.data.access_token;
        });
    }
    parseSyncData(account) {
        var _a, _b, _c, _d;
        let dayPasses = {};
        try {
            JSON.parse(account.DayPasses || '{}');
        }
        catch (err) {
            console.log(`error parsing day pass ${account.DayPasses} for outseta ID ${(_a = account.CurrentSubscription) === null || _a === void 0 ? void 0 : _a.Uid}`);
        }
        // = Boolean(outsetaResponse.PaymentInformation)
        const accountStage = account.AccountStage;
        const currentOutsetaSubscription = account.CurrentSubscription;
        const latestOutsetaSubscription = account.LatestSubscription;
        const nextSubscriptionStartDate = new Date((_b = latestOutsetaSubscription === null || latestOutsetaSubscription === void 0 ? void 0 : latestOutsetaSubscription.StartDate) !== null && _b !== void 0 ? _b : '').getTime() > Date.now()
            ? new Date((_c = latestOutsetaSubscription === null || latestOutsetaSubscription === void 0 ? void 0 : latestOutsetaSubscription.StartDate) !== null && _c !== void 0 ? _c : '')
            : null;
        const hasCreditCard = Boolean(account.PaymentInformation);
        return {
            id: account.Uid,
            data: {
                accountStage,
                nextSubscriptionStartDate,
                currentSubscription: currentOutsetaSubscription
                    ? {
                        id: currentOutsetaSubscription.Uid,
                        planId: currentOutsetaSubscription.Plan.Uid,
                        renewalDate: (_d = currentOutsetaSubscription.RenewalDate) !== null && _d !== void 0 ? _d : null,
                    }
                    : null,
                dayPasses,
                hasCreditCard,
            },
        };
    }
    getSyncData(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const outsetaResponse = yield this.api.crm.accounts.get(id, {
                fields: 'Uid,CurrentSubscription.*, CurrentSubscription.Plan.*, LatestSubscription.*, DayPasses,AccountStage,PaymentInformation.*',
            });
            if (!outsetaResponse)
                throw new Error('Outseta User not found');
            return this.parseSyncData(outsetaResponse);
        });
    }
    getAllSyncData() {
        return __awaiter(this, void 0, void 0, function* () {
            let cnt = 0;
            let total = 0;
            let items = [];
            do {
                const outsetaResponse = yield this.api.crm.accounts.getAll({
                    //    updated: 1,
                    limit: 25,
                    offset: cnt,
                    fields: 'Uid,CurrentSubscription.*, CurrentSubscription.Plan.*, DayPasses,AccountStage,PaymentInformation.*',
                });
                total = outsetaResponse.metadata.total;
                cnt += 1;
                if (!outsetaResponse)
                    throw new Error('Outseta User not found');
                items = [
                    ...items,
                    ...outsetaResponse.items.map((account) => {
                        return this.parseSyncData(account);
                    }),
                ];
                console.log(`${items.length}/${total}`);
            } while (items.length < total);
            return items;
        });
    }
    reportCustomActivity(user, activity, data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.request('POST', 'activities/customactivity', {
                EntityType: 1,
                ActivityData: data,
                EntityUid: user.outsetaAccountId,
                Title: activity,
                Description: `${user.username} ${activity}`,
            });
        });
    }
    getUnpaidInvoices() {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = (yield this.request('GET', 'billing/invoices?BillingInvoiceStatus=1&fields=Uid,Amount,AmountOutstanding,BillingInvoiceStatus,InvoiceDate,IsUserGenerated,Subscription.Account.Name,Subscription.Account.Uid,Subscription.Account.PaymentInformation.LastFourDigits,Subscription.Plan.Name,Subscription.Plan.Uid&offset=0&limit=25&orderBy=InvoiceDate+DESC'));
            return resp.data.items;
        });
    }
    addPaymentToInvoice(invoiceId, accountId, amount) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.request('POST', 'billing/transactions/payment', {
                Account: { Uid: accountId },
                Invoice: { Uid: invoiceId },
                TransactionDate: new Date(),
                Amount: -amount,
            });
        });
    }
    sendInvoiceEmail(invoiceId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.request('POST', `/billing/invoices/${invoiceId}/sendinvoiceemail`, {});
        });
    }
    getAllTransactionsByAccount(accountId) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.request('GET', `billing/transactions/${accountId}`);
            return resp.data.items;
        });
    }
}
exports.OutsetaClient = OutsetaClient;
//# sourceMappingURL=client.js.map